import { connect } from "react-redux";

import ShipmentStatusView from "./ShipmentStatusView";
import LadsState from "../lads/LadsState";
import { fetchWatchlist } from "../user-data/UserDataState";
import SearchState from "../shipment-search/ShipmentSearchState";
import SavedSearchState from "../shipment-search/SavedSearchState";
import DomainDataState from "../domain-data/DomainDataState";

import ShipmentsStatusState from "./ShipmentsState";

function mapStateToProps(state) {
  return {
    savedSearches: SavedSearchState.selectors.getSavedSearches(state),
    watchlistData: state.user.watchlistData,
    locations: state.locations.data,
    allShipmentsTotals: state.shipmentsStatus.all_shipments,
    watchlistShipments: state.shipmentsStatus.watchlistShipments,
    exceptionTypes: DomainDataState.selectors.getExceptionTypes(state),
    statusTypes: DomainDataState.selectors.getStatusTypes(state),
    shipmentModes: DomainDataState.selectors.getShipmentModes(state),
    lads: LadsState.selectors.getLadsList(state)
  };
}

function mapDispatchToProps(dispatch) {
  const {
    fetchShipmentTotals,
    fetchShipmentTotalsByLocation,
    fetchShipmentTotalsByPart
  } = ShipmentsStatusState.actionCreators;
  return {
    fetchSavedSearches: () => dispatch(SavedSearchState.actionCreators.fetchSavedSearches()),
    fetchWatchlist: () => dispatch(fetchWatchlist()),
    fetchShipmentTotals: () => dispatch(fetchShipmentTotals()),
    fetchShipmentTotalsByPart: part =>
      dispatch(fetchShipmentTotalsByPart(part)),
    fetchShipmentTotalsByLocation: location =>
      dispatch(fetchShipmentTotalsByLocation(location)),
    pushSearchView: () => dispatch({ type: "SHIPMENT_SEARCH" }),
    setSearchFilter: (key, value) =>
      dispatch(SearchState.actionCreators.setSearchFilter(key, value)),
    setSearchCategory: category =>
      dispatch(SearchState.actionCreators.setSearchCategory(category)),
    setSearch: (label, value) => dispatch(SearchState.actionCreators.setSearch(label, value)),
    clearSearchFilters: () =>
      dispatch(SearchState.actionCreators.clearSearchFilters()),
    searchShipments: (searchObj, searchCategory, searchFilters) =>
      dispatch(
        SearchState.actionCreators.searchShipments(
          searchObj,
          searchCategory,
          searchFilters
        )
      ),
    pushLocationDetailView: locID =>
      dispatch({ type: "LOCATION_DETAIL", payload: { location_id: locID } })
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShipmentStatusView);



// WEBPACK FOOTER //
// ./src/modules/shipment-status/ShipmentStatusViewContainer.js